<div class="w-100 m-0">

    <form class="" [formGroup]="formComunication">
        <div class="row   hight_25 mt-1 mb-2 justify-content-between">
            <div class="col-3">
                <div class="form-group pr-2 ">
                    <div class="gestion_terceros datos_identificacion">

                        <calendario [showButtonBar]="false" class="calendario" [formulario]="formComunication"
                            [controlName]="'Fecha1'">
                        </calendario>
                    </div>
                </div>
            </div>

            <div class="col-3">
                <div class="form-group pr-2 ">
                    <div class="gestion_terceros datos_identificacion">

                        <calendario [showButtonBar]="false" class="calendario" [formulario]="formComunication"
                            [controlName]="'Fecha2'">
                        </calendario>
                    </div>
                </div>
            </div>

            <div class="col-3">
                <div class="form-group pr-2 datos_identificacion">
                    <kendo-dropdownlist [data]="selectorMensajes" [textField]="'Description'" [valueField]="'Code'"
                        [valuePrimitive]="true" formControlName="Seleccionado"
                        class="form-control  float-right anchurax90 ">
                        <ng-template kendoDropDownListItemTemplate let-dataItem>
                            <span class="kendo_list_template">{{ dataItem.Description }}</span>
                        </ng-template>
                    </kendo-dropdownlist>
                </div>
            </div>

            <div class="col-2 ">
                <button (click)="searchComunicaton()" type="button" class="btn btn-secondary btn-sm">
                    {{'labels.buscar' | translate}}
                </button>
            </div>
        </div>
    </form>
    <!-- (pChange)="pageChange($event)"  -->
    <dms-generic-table [dataTable]="dataTable" [isLoading]="isLoadingVehicles" [hasPage]="false">
    </dms-generic-table>


</div>
